import React, { Fragment } from 'react'
import numeral from 'numeral'
import { FormattedMessage } from 'react-intl'
import { AdditionalInfo, Button, List } from 'src/Components'
import { CMARequestFinished } from 'src/constants/trackingEvents'

import styles from './Step.module.scss'

const CMASectionHomeFacts = ({ setAnswer, home }) => {
  const handleAnswer = answer => () => {
    setAnswer({ question: 'homeFactsCorrect', answer })
  }

  return (
    <Fragment>
      <AdditionalInfo.Heading>
        <FormattedMessage
          id='Homeowner.cmaWizard.homeFacts.headline'
          defaultMessage='Are these home facts correct?'
        />
      </AdditionalInfo.Heading>
      <List.Bulleted.Inline>
        <FormattedMessage
          id='Homeowner.cmaWizard.homeFacts.bedCount'
          defaultMessage='{renderedNumber} {actualNumber, plural, one {Bed} other {Beds}}'
          values={{
            actualNumber: home.bedrooms,
            renderedNumber: (
              <span className={styles.factNum}>{home.bedrooms}</span>
            )
          }}
        />
        <FormattedMessage
          id='Homeowner.cmaWizard.homeFacts.bathCount'
          defaultMessage='{renderedNumber} {actualNumber, plural, one {Bath} other {Baths}}'
          values={{
            actualNumber: home.bathrooms,
            renderedNumber: (
              <span className={styles.factNum}>{home.bathrooms}</span>
            )
          }}
        />
        <FormattedMessage
          id='Homeowner.cmaWizard.homeFacts.totalSqft'
          defaultMessage='{renderedNumber} Total SqFt'
          values={{
            renderedNumber: (
              <span className={styles.factNum}>
                {numeral(home.finishedSqFt).format('0,0')}
              </span>
            )
          }}
        />
      </List.Bulleted.Inline>
      <Button.Group className={styles.buttonGroup}>
        <Button onClick={handleAnswer(true)} track={CMARequestFinished}>
          <FormattedMessage
            id='Homeowner.cmaWizard.homeFacts.yesButton'
            defaultMessage='Yes'
          />
        </Button>
        <Button onClick={handleAnswer(false)} track={CMARequestFinished}>
          <FormattedMessage
            id='Homeowner.cmaWizard.homeFacts.noButton'
            defaultMessage='No'
          />
        </Button>
      </Button.Group>
    </Fragment>
  )
}

export default CMASectionHomeFacts
